import React from 'react';
import TruncateWithTooltip from '@/components/TruncateWithTooltip';

interface TeamBadgeProps {
  color?: string;
  text: string;
  className?: string;
  Truncate?: boolean;
  truncateLength?: number;
  tooltipText?: string;
}

const TeamBadge: React.FC<TeamBadgeProps> = ({
  color,
  text,
  className = '',
  Truncate = true,
  truncateLength = 20,
}) => {
  return (
    <div className={`${className} badge-wrapper`}>
      {color && (
        <div style={{ backgroundColor: color }} className='badge-color'></div>
      )}
      {Truncate ? (
        <TruncateWithTooltip
          text={text}
          max={truncateLength}
          render={(t) => <p>{t}</p>}
          disableTooltip={false}
        />
      ) : (
        <p>{text}</p>
      )}
    </div>
  );
};

export default TeamBadge;
